import React from "react";
import Toast from "../components/style-guide/toast/Toast";
import {toast} from "react-toastify";

const options = {hideProgressBar: true, autoClose: 5000};

export const toastHelper = class {
  static error(message) {
    this.show('error', message);
  }

  static info(message) {
    this.show('info', message);
  }

  static success(message) {
    this.show('success', message);
  }

  static warning(message) {
    this.show('warning', message);
  }

  static show(type, message) {
    toast(<Toast type={type} message={message}/>, options);
  }

  static showGenericErrorMessage() {
    toast(<Toast type="error" message="Lo sentimos ha ocurido un error en el servicio. Intente nuevamente."/>, options);
  }
};